/** Usercentrics (CMP v3) data processing service IDs of the video players. */
export const UC_SERVICE_ID = {
  video3Q: 'qxiCD5aN_',
  vimeo: 'HyEX5Nidi-m',
} as const;

interface UcConsentDetails {
  services?: Record<string, { consent?: { given?: boolean } }>;
}

interface UcCmp {
  getConsentDetails(): Promise<UcConsentDetails>;
  updateServicesConsents(
    consents: { id: string; consent: boolean }[]
  ): Promise<void>;
  saveConsents(type?: 'EXPLICIT' | 'IMPLICIT'): Promise<void>;
  showServiceDetails(serviceId: string): Promise<void>;
  showSecondLayer(activeTab?: string): Promise<void>;
}

declare global {
  interface Window {
    __ucCmp?: UcCmp;
  }
}

export const isGranted = (
  details: UcConsentDetails | undefined,
  serviceId: string
): boolean => details?.services?.[serviceId]?.consent?.given === true;
